import React,{createContext,useReducer} from 'react'
import PropTypes from 'prop-types'

export const SWITCH_TAB = "SWITCH_TAB"
export const INIT = "INIT"
export const UPDATE_CONFIG = "UPDATE_CONFIG"
export const UPDATE_ADDONS = "UPDATE_ADDONS"

export const SelectHostingContext = createContext()


export const SelectHostingInitialState = {
  selectedTab: 'build',
}

export const SelectHostingReducer =  (state,action) => {
  const getConfig = () =>{
    let config = {
      ...state,
      config: action.config
    }
    if(action.selectedTab){
      config['selectedTab'] = action.selectedTab
    }
    return config
  }
  switch (action.type) {
    case SWITCH_TAB:
      return ({
        ...state,
        selectedTab: action.selectedTab
      })
    case INIT:
      return ({
        ...state,
        data:action.data,
        config: action.config,
        addons: action.addons
      })
    case UPDATE_CONFIG:
      return (getConfig())
    case UPDATE_ADDONS:
      return ({
        ...state,
        addons: action.addons
      })
    default:
      return state
  }
}

export const SelectHostingProvider = (props) =>{
  const {children,reducer,initialState} = props
  const [state,dispatch] = useReducer(reducer,initialState)
  return (
      <SelectHostingContext.Provider value={{state,dispatch}}>
        {children}
      </SelectHostingContext.Provider>
  )
}


SelectHostingProvider.propTypes = {
  children: PropTypes.object,
  reducer: PropTypes.any,
  initialState: PropTypes.object
}







